import RootLayout from "@/app/layout";
import data from '../../data/angebot/data.json';
import { DetailAngebotSection } from "@/app/components/Sections/DetailAngebotSection";
import Head from "next/head";

export const metadata = {
    title: 'Hebamme Lea Stiffler | Geburtsvorbereitungskurs',
    description: 'Bietet privaten Geburtsvorbereitungskurs in Chur an. Informiert und bereitet werdende Eltern auf die Geburt vor. Lernen Sie alles Wichtige rund ums Thema Geburt und Wochenbett.',
    keywords: 'Geburtsvorbereitungskurs Chur, private Geburtsvorbereitung, werdende Eltern Beratung, Geburt Vorbereitung, Wochenbett Informationen, Hebamme Chur',
    canonicalUrl: 'https://hebamme-leastiffler.ch/geburtsvorbereitungskurs'
}


export async function getStaticProps() {
    return { props: { data } }
}

export default function Geburtsvorbereitungskurs({ data }) {
    const geburtsvorbereitungskursData = data.Geburtsvorbereitungskurs;

    return (
        <RootLayout>
            <Head>
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <link rel="canonical" href={metadata.canonicalUrl} />
            </Head>
            <DetailAngebotSection data={geburtsvorbereitungskursData} />
        </RootLayout>
    )
}